import {ReactionApiModel} from '../../api/models/reaction.api.model';
import {ReactedWithEnum} from '../enums/reacted-with.enum';

export function reactionDisplayValue(reaction: ReactionApiModel): string {
  return reaction.reactedWith === ReactedWithEnum.CUSTOM ? reaction.customEmoji || '❔' : reaction.reactedWith;
}

export function isStandardReaction(value: string): boolean {
  return value !== ReactedWithEnum.CUSTOM && Object.values(ReactedWithEnum).includes(value as ReactedWithEnum);
}
